// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.lcHomepageWrapper {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  height: calc(100vh - var(--lc-header-height) - var(--header-height));
}

.lcHomepage {
  display: flex;
  flex-direction: column;
  justify-content: center;
  margin: 1em;
  max-width: 600px;
  line-height: var(--lc-line-height);
}

.lcHomepageHeader {
  font-size: 2em;
  margin-bottom: 1em;
  color: #000;
}

.lcHomepageParagraph {
  font-size: 1.1em;
  line-height: var(--lc-line-height);
  margin-bottom: 2em;
  color: #555;
}

a.lcHomepageButton {
  text-decoration: none;
  padding: 0.7em 1.7em;
  font-size: 1.2em;
  border-radius: 3em;
  border: none;
  background-color: #6a72fb;
  color: #fff;
  cursor: pointer;
  transition: background 0.1s;
  box-shadow: 0 0.3em 0.6em #0003;
}

.lcHomepageButton:hover {
  background-color: #545cfb;
}

.lcHomepageChatbotCredentials {
  --slidedown-px: -20px;
  animation: slidedown 500ms;

  & label {
    display: block;
    color: var(--lc-accent-color);
    font-weight: bold;
    font-size: var(--font-size-normal);
    margin-block: 6px;
  }

  & input {
    margin-bottom: var(--lc-margin-medium);
    padding: 10px;
    width: 100%;
    box-sizing: border-box;
  }

  & a.lcButton {
    font-size: 13px;
    padding: 3px 9px;
    margin-inline: 7px;
    position: relative;
    top: -2px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/frontend/components/LanguageCoach/HomePage.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,sBAAsB;EACtB,oEAAoE;AACtE;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,WAAW;EACX,gBAAgB;EAChB,kCAAkC;AACpC;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,kCAAkC;EAClC,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,qBAAqB;EACrB,oBAAoB;EACpB,gBAAgB;EAChB,kBAAkB;EAClB,YAAY;EACZ,yBAAyB;EACzB,WAAW;EACX,eAAe;EACf,2BAA2B;EAC3B,+BAA+B;AACjC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,qBAAqB;EACrB,0BAA0B;;EAE1B;IACE,cAAc;IACd,6BAA6B;IAC7B,iBAAiB;IACjB,kCAAkC;IAClC,iBAAiB;EACnB;;EAEA;IACE,sCAAsC;IACtC,aAAa;IACb,WAAW;IACX,sBAAsB;EACxB;;EAEA;IACE,eAAe;IACf,gBAAgB;IAChB,kBAAkB;IAClB,kBAAkB;IAClB,SAAS;EACX;AACF","sourcesContent":[".lcHomepageWrapper {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  flex-direction: column;\n  height: calc(100vh - var(--lc-header-height) - var(--header-height));\n}\n\n.lcHomepage {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  margin: 1em;\n  max-width: 600px;\n  line-height: var(--lc-line-height);\n}\n\n.lcHomepageHeader {\n  font-size: 2em;\n  margin-bottom: 1em;\n  color: #000;\n}\n\n.lcHomepageParagraph {\n  font-size: 1.1em;\n  line-height: var(--lc-line-height);\n  margin-bottom: 2em;\n  color: #555;\n}\n\na.lcHomepageButton {\n  text-decoration: none;\n  padding: 0.7em 1.7em;\n  font-size: 1.2em;\n  border-radius: 3em;\n  border: none;\n  background-color: #6a72fb;\n  color: #fff;\n  cursor: pointer;\n  transition: background 0.1s;\n  box-shadow: 0 0.3em 0.6em #0003;\n}\n\n.lcHomepageButton:hover {\n  background-color: #545cfb;\n}\n\n.lcHomepageChatbotCredentials {\n  --slidedown-px: -20px;\n  animation: slidedown 500ms;\n\n  & label {\n    display: block;\n    color: var(--lc-accent-color);\n    font-weight: bold;\n    font-size: var(--font-size-normal);\n    margin-block: 6px;\n  }\n\n  & input {\n    margin-bottom: var(--lc-margin-medium);\n    padding: 10px;\n    width: 100%;\n    box-sizing: border-box;\n  }\n\n  & a.lcButton {\n    font-size: 13px;\n    padding: 3px 9px;\n    margin-inline: 7px;\n    position: relative;\n    top: -2px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
